export const userData = {
  name: 'Jamie Thompson',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  perDiemRemaining: 45.75,
  perDiemTotal: 75.0,
  location: 'San Francisco, CA',
  perDiemDate: '2025-10-16',
  company: 'Acme Global, Inc.',
}
export const recentExpenses = [
  {
    id: 1,
    date: '2025-10-15',
    merchant: 'Starbucks',
    amount: 8.45,
    status: 'Approved',
  },
  {
    id: 2,
    date: '2025-10-14',
    merchant: 'Subway',
    amount: 12.3,
    status: 'Approved',
  },
  {
    id: 3,
    date: '2025-10-13',
    merchant: 'Office Supplies Co.',
    amount: 28.5,
    status: 'Under Review',
  },
]
export const historyExpenses = [
  ...recentExpenses,
  {
    id: 4,
    date: '2025-10-10',
    merchant: 'Airport Taxi',
    amount: 45.0,
    status: 'Approved',
  },
  {
    id: 5,
    date: '2025-10-09',
    merchant: 'Hotel Restaurant',
    amount: 32.85,
    status: 'Flagged',
  },
  {
    id: 6,
    date: '2025-10-08',
    merchant: 'Coffee Shop',
    amount: 5.25,
    status: 'Approved',
  },
]
export const coworkers = [
  {
    id: 1,
    name: 'Sarah Miller',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    id: 2,
    name: 'James Wilson',
    avatar: 'https://randomuser.me/api/portraits/men/41.jpg',
  },
  {
    id: 3,
    name: 'Emily Davis',
    avatar: 'https://randomuser.me/api/portraits/women/23.jpg',
  },
  {
    id: 4,
    name: 'Michael Brown',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
  },
  {
    id: 5,
    name: 'Jessica Taylor',
    avatar: 'https://randomuser.me/api/portraits/women/85.jpg',
  },
]
